import register from 'ShopUiBundle/modules/app/registry';

import './style.scss';

// tslint:disable-next-line
register('bike-detail-geo-table', () => import(/* webpackMode: "lazy" */'./bike-detail-geo-table'));
